import { render, staticRenderFns } from "./ClienteInformacion.vue?vue&type=template&id=ab65f1a8&"
import script from "./ClienteInformacion.vue?vue&type=script&lang=js&"
export * from "./ClienteInformacion.vue?vue&type=script&lang=js&"
import style0 from "./ClienteInformacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent})
